import { identifyChannel } from '@mm/state/helpers/live-chat-helpers';
import { ReactComponent as FBIcon } from 'assets/icons/live-chat-fb.svg';
import { ReactComponent as WebchatIcon } from 'assets/icons/live-chat-webchat.svg';
import { ReactComponent as SMSIcon } from 'assets/icons/sms.svg';
import { ReactComponent as InstagramIcon } from 'assets/instagram.svg';
import { ReactComponent as FBIconNew } from 'assets/fb-icon.svg';
import { ReactComponent as SMSIconNew } from 'assets/smartphone.svg';
import { ReactComponent as GmailIcon } from 'assets/gmail.svg';
import { ReactComponent as XRayMailIcon } from 'assets/x-ray-email.svg';
import { ReactComponent as WebchatIconNew } from 'assets/webchat-new.svg';
import { ReactComponent as ZapierIcon } from 'assets/icons/zapier-icon.svg';
import { ReactComponent as AudienceIcon } from 'assets/audience.svg';
import { ReactComponent as LeadMagnet } from 'assets/lead-generation-magnet.svg';

import React, { ReactNode } from 'react';
import { FileExcelFilled, UsergroupAddOutlined } from '@ant-design/icons';

export const VISIBLE_CHANNELS = [
  'email',
  'sms',
  'facebook',
  'instagram',
  'webChat',
  'webchat',
  'zapier', // Not really a channel, but kind of
  'csv', // Not really a channel
  'leadsDb',
  'xray',
  'audience',
] as const;
export type ChannelType = typeof VISIBLE_CHANNELS[number];

export const ChannelIcon = (props: {
  className?: string;
  remoteUserId?: string;
  channel?: ChannelType;
  customMap?: Partial<Record<ChannelType, () => ReactNode>>;
  iconSize?: number;
}) => {
  const {
    remoteUserId,
    channel: channelProp,
    className,
    customMap,
    iconSize,
  } = props;

  if (!remoteUserId && !channelProp) {
    return null;
  }

  const channel = remoteUserId ? identifyChannel(remoteUserId) : channelProp;
  const iconStyleProps = { width: iconSize, height: iconSize };
  let Icon;
  switch (channel) {
    case 'webChat':
    case 'webchat':
      Icon = () => <WebchatIconNew style={iconStyleProps} />;
      break;
    case 'sms':
      Icon = () => <SMSIconNew style={iconStyleProps} />;
      break;
    case 'instagram':
      Icon = () => <InstagramIcon style={iconStyleProps} />;
      break;
    case 'email':
      Icon = () => <GmailIcon style={iconStyleProps} />;
      break;
    case 'zapier':
      Icon = props => (
        <ZapierIcon style={{ maxWidth: 16, ...iconStyleProps }} {...props} />
      );
      break;
    case 'csv':
      Icon = props => (
        <FileExcelFilled
          style={{ color: '#006D75', fontSize: iconSize }}
          {...props}
        />
      );
      break;
    case 'audience':
      Icon = props => (
        <AudienceIcon style={{ maxWidth: 16, ...iconStyleProps }} {...props} />
      );
      break;
    case 'leadsDb':
      Icon = () => <UsergroupAddOutlined style={{ fontSize: iconSize }} />;
      break;
    case 'xray':
      Icon = () => <LeadMagnet style={iconStyleProps} />;
      break;
    case 'facebook':
    default:
      Icon = () => <FBIconNew style={iconStyleProps} />;
  }

  const customIcon = customMap?.[`${channel}`];

  if (customMap && channel && customIcon) {
    Icon = customIcon;
  }

  return <Icon className={className} />;
};

export { FBIcon, WebchatIcon, SMSIcon, XRayMailIcon };
